import { quiz } from '@constants/data'
import { useState } from 'react'

interface Params {
  data?: any
  date?: string
  stage?: string
  screen?: string
  current_screen?: number
  history?: number[]
}

export function useFetch(action = 'quiz_form', options?: RequestInit) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const trigger = async (params?: Params) => {
    setIsLoading(true)

    const res = await fetch(quiz.ajax_url, {
      method: 'POST',
      ...options,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        ...options?.headers
      },
      body: new URLSearchParams({
        action,
        data: JSON.stringify({
          uuid: quiz.data.client_uuid,
          nonce: quiz.nonce,
          form: 'short',
          ...params
        })
      })
    })
    const json = await res.json()

    if (!res.ok) {
      const reason = json?.message || 'Something went wrong'

      setError(reason)
      setIsLoading(false)

      return Promise.reject(reason)
    }

    setError('')
    setIsLoading(false)

    return json
  }

  return { trigger, isLoading, error }
}
